export default {
      id: "event-share-news-header-usage",
      viewBox: "0 0 60 78",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#event-share-news-header",
      toString: function () {
        return this.url;
      }
    }